/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NftSaleConfigLineItem
 */
export interface NftSaleConfigLineItem {
    /**
     * 
     * @type {string}
     * @memberof NftSaleConfigLineItem
     */
    nftTracker: string;
    /**
     * 
     * @type {number}
     * @memberof NftSaleConfigLineItem
     */
    quantity: number;
}

export function NftSaleConfigLineItemFromJSON(json: any): NftSaleConfigLineItem {
    return NftSaleConfigLineItemFromJSONTyped(json, false);
}

export function NftSaleConfigLineItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): NftSaleConfigLineItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'nftTracker': json['nftTracker'],
        'quantity': json['quantity'],
    };
}

export function NftSaleConfigLineItemToJSON(value?: NftSaleConfigLineItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'nftTracker': value.nftTracker,
        'quantity': value.quantity,
    };
}


